function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {

  //Only apply role button to summaries whose parent is not a <details>, per ADA requirements
  if(summary.parentElement.tagName !== "DETAILS") {
    summary.setAttribute('role', 'button');
  }

  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  } 

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    //this.input.addEventListener('change', this.updateQtyMax);
    this.changeEvent = new Event('change', { bubbles: true })
    this.input.addEventListener('keydown', this.onKeydown.bind(this));
    this.input.addEventListener('blur', this.onBlur.bind(this));
    this.lineItems = document.querySelectorAll(".cart-item");

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }


  async onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    const quantityInput = event.target.closest('quantity-input').querySelector('input');
  
    const cartData = await fetch('/cart.js').then(response => response.json());
    
    const parentVariantId = quantityInput.dataset.variant;
    const max = parseInt(quantityInput.dataset.max) || Infinity;
    let currentParentQuantity = 0;
  
    cartData.items.forEach((item) => {
      if (item.id == parentVariantId) {
        currentParentQuantity += item.quantity;
      }
    });
  
    const belowMax = (currentParentQuantity < max);
    // Prevent input from exceeding max quantity
    if (event.target.name === 'minus') {
      this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    } else if (event.target.name === 'plus' && belowMax) {
      this.input.stepUp();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    } else {
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateLiveRegions(quantityInput.dataset.index, cartStrings.maxQuantity); 
    }
  }

  onKeydown(event){
    const value = parseInt(event.target.value);
    const max = parseInt(event.target.dataset.max);
    const line = event.target.dataset.index;
    const parentVariantId = event.target.dataset.variant;
    const previousValue = this.querySelector('.quantity__input')


    if (event.key === "Enter") {
        event.preventDefault();

        if (max && value > max) {
            event.target.value = previousValue.getAttribute('value');
            const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');

            this.lineItems.forEach( item => {
              if(item.dataset.variant == parentVariantId) {
                cartItems.updateLiveRegions(item.id.split("-").pop(), cartStrings.maxQuantity);
              }
            })

        }

        event.target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  onBlur(event){
      const value = parseInt(event.target.value);
      const max = parseInt(event.target.dataset.max);
      const line = event.target.dataset.index;
      const parentVariantId = event.target.dataset.variant;
      const previousValue = this.querySelector('.quantity__input')

      if (max && value > max) {
          event.target.value = max;
          const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');

          this.lineItems.forEach( item => {
            if(item.dataset.variant == parentVariantId) {
              cartItems.updateLiveRegions(item.id.split("-").pop(), cartStrings.maxQuantity);
            }
          })
          
          return;
      }

      event.target.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /** Setting Quantity input to maximum product quantity on keyboard input **/
  // updateQtyMax() {
  //   let qtyMax = this.input.getAttribute("max");

  //   if (qtyMax != null && Number(this.input.value) > qtyMax) {
  //     this.input.value = (qtyMax != 0) ? qtyMax : 1;
  //   }
  // }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    document.body.dispatchEvent(new CustomEvent('modalOpened'));
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();

    if (this.classList.contains('autoplay')) {
      if (this.classList.contains('youtube')) {
        document.querySelector('.js-youtube').src += "&autoplay=1";
      } else {
        document.querySelector('.js-vimeo').src += "?autoplay=1";
      }
    }
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class GalleryComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = document.getElementById('GalleryComponent').querySelector('[id^="Slider-"]');
    this.sliderItems = this.slider.querySelectorAll('[id^="Slide-"]');
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.enableSliderLooping = false;
    this.galleryLiveRegion = document.querySelector('[id^="GalleryStatus"]');

    // Arrow controls for PDP image gallery
    this.isMobile = window.innerWidth < 750;
    if (!this.isMobile) {
      this.sliderControls = document.querySelector('.product .slider-controls');
      if (!this.sliderControls) return;
      this.sliderControlPrevious = this.sliderControls.querySelector('.slider-control--prev');
      this.sliderControlPrevious.setAttribute('disabled', 'disabled');
      this.sliderControlNext = this.sliderControls.querySelector('.slider-control--next');
      this.sliderControlPrevious.addEventListener('click', this.onControlClick.bind(this));
      this.sliderControlPrevious.addEventListener('keypress', event => {
        if (event.key === 'Enter') this.onControlClick.bind(this);
        this.clickedPreviousWithKeyboard = true;
      });
      this.sliderControlNext.addEventListener('click', this.onControlClick.bind(this));
      this.sliderControlNext.addEventListener('keypress', event => {
        if (event.key === 'Enter') this.onControlClick.bind(this);
        this.clickedNextWithKeyboard = true;
      });
      this.activeSlide = document.querySelector('.product__media-item.is-active');
      if (this.activeSlide.dataset.mediaPosition === '1') {
        this.sliderControlPrevious.setAttribute('disabled','disabled');
      }
      this.thumbnails = document.querySelectorAll('.thumbnail-list__item');
      let activeThumbs = [];
      this.thumbnails.forEach(thumb => {
        setTimeout(() => {
          if (thumb.style.display === 'block') activeThumbs.push(thumb);
          thumb.addEventListener('click', () => this.onThumbClick(thumb, activeThumbs));
        },500);
      });
      this.arrowsVisibility();

      document.addEventListener('keydown', this.onArrowDown.bind(this));

      this.announceLiveRegion(this.activeSlide, this.activeSlide.dataset.mediaPosition);
    }

    if (!this.slider) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.this.slider.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }
  }

  arrowsVisibility() {
    if (this.sliderItems.length === 1) {
      this.sliderControls.style.display = 'none';
    } else {
      this.sliderControls.removeAttribute('style');
    }
  }

  onControlClick(event) {
    event.preventDefault();
    this.activeSlide = document.querySelector('.product__media-item.is-active');
    this.nextElement = this.activeSlide.nextElementSibling;
    this.previousElement = this.activeSlide.previousElementSibling;

    if (event.currentTarget.name === 'next_slide' && this.nextElement) {
      this.activeSlide.classList.remove('is-active');
      this.nextElement.classList.add('is-active');
      this.sliderControlPrevious.removeAttribute('disabled');
      this.announceLiveRegion(this.nextElement, this.nextElement.dataset.mediaPosition);
      if (!this.nextElement.nextElementSibling) {
        this.sliderControlNext.setAttribute('disabled','disabled');
        if (this.clickedNextWithKeyboard === true) {
          this.sliderControlPrevious.focus();
        }
      }
    } else if (event.currentTarget.name === 'previous_slide' && this.previousElement) {
      this.activeSlide.classList.remove('is-active');
      this.previousElement.classList.add('is-active');
      this.announceLiveRegion(this.previousElement, this.previousElement.dataset.mediaPosition);
      if (!this.previousElement.previousElementSibling) {
        this.sliderControlPrevious.setAttribute('disabled','disabled');
        this.sliderControlNext.removeAttribute('disabled');
      }
      if (this.clickedPreviousWithKeyboard === true) {
        this.sliderControlNext.removeAttribute('disabled');
      }
      if (!this.previousElement.previousElementSibling && this.clickedPreviousWithKeyboard === true) {
        this.sliderControlNext.focus();
      }
    }
  }

  onThumbClick(thumb, activeThumbs) {
    let lastElement = activeThumbs[activeThumbs.length - 1];
    activeThumbs.forEach(() => {
      if (thumb === lastElement) {
        this.sliderControlNext.setAttribute('disabled','disabled');
        this.sliderControlPrevious.removeAttribute('disabled');
      } else if (thumb === activeThumbs[0]) {
        this.sliderControlPrevious.setAttribute('disabled','disabled');
        this.sliderControlNext.removeAttribute('disabled');
      } else {
        this.sliderControlPrevious.removeAttribute('disabled');
        this.sliderControlNext.removeAttribute('disabled');
      }
    });
  }

  onArrowDown(event) {
    const slides = document.querySelectorAll('.product__media-item');
    const galleryComponent = document.querySelector('gallery-component');
    const galleryControls = galleryComponent.querySelectorAll('.slider-control');
    const activeSlide = document.querySelector('.product__media-item.is-active');
    const nextElement = activeSlide.nextElementSibling;
    const previousElement = activeSlide.previousElementSibling;

    galleryControls.forEach(el => {
      if (el === document.activeElement && (event.key === 'ArrowRight' || event.keyCode === 39)) {
        if (nextElement) {
          activeSlide.classList.remove('is-active');
          nextElement.classList.add('is-active');
          this.sliderControlPrevious.removeAttribute('disabled');
        }
        if (!nextElement?.nextElementSibling) {
          this.sliderControlNext.setAttribute('disabled','disabled');
          this.sliderControlPrevious.focus();
        }
      } 
      if (el === document.activeElement && (event.key === 'ArrowLeft' || event.keyCode === 37)) {
        if (previousElement) {
          activeSlide.classList.remove('is-active');
          previousElement.classList.add('is-active');
          this.sliderControlNext.removeAttribute('disabled');
        }
        if (!previousElement?.previousElementSibling) {
          this.sliderControlPrevious.setAttribute('disabled','disabled');
          this.sliderControlNext.focus();
        }
      }
    });
  }

  announceLiveRegion(activeItem, position) {
    const image = activeItem.querySelector('.product__modal-opener--image img');
    if (!image) return;
    image.onload = () => {
      this.galleryLiveRegion.setAttribute('aria-hidden', false);
      this.galleryLiveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
        '[index]',
        position
      );
      setTimeout(() => {
        this.galleryLiveRegion.setAttribute('aria-hidden', true);
      }, 2000);
    };
    image.src = image.src;
  }
}

customElements.define('gallery-component', GalleryComponent);

class ThumbnailComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('thumbnail-component', ThumbnailComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VideoSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="VideoSlider-"]');
    this.sliderItems = this.querySelectorAll('[id^="VideoSlide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('[id^="VideoSlider-"] .slider-counter--current');
    this.pageTotalElement = this.querySelector('[id^="VideoSlider-"] .slider-counter--total');
    this.prevButton = this.querySelector('.slideshow-arrows-navigation button[name="previous"]');
    this.nextButton = this.querySelector('.slideshow-arrows-navigation button[name="next"]');

    if (!this.slider) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="VideoSlide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('video-slider-component', VideoSliderComponent);

class VideoSlideshowComponent extends VideoSliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.prevButton = this.querySelector('.slider-button--prev');
    this.nextButton = this.querySelector('.slider-button--next');

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();
    this.initVideoControls();
    this.buildDots();

    this._lastSlidesPerView = this.getSlidesPerView();
    window.addEventListener('resize', this.onResize.bind(this));

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  getSlidesPerView() {
    const w = window.innerWidth;
    if (w >= 1024) return 5;
    if (w >= 750)  return 3;
    return 1;
  }

  buildDots() {
    const controlWrapper = this.sliderControlWrapper;
    const dotContainer = controlWrapper.querySelector('.slideshow__control-wrapper');
    if (!dotContainer) return;

    const total = this.sliderItemsToShow.length;
    const perView = this.getSlidesPerView();
    const dotCount = Math.ceil(total / perView);

    dotContainer.innerHTML = '';
    this.sliderControlLinksArray = [];

    for (let i = 0; i < dotCount; i++) {
      const btn = document.createElement('button');
      btn.className = 'slider-counter__link slider-counter__link--dots link';
      btn.setAttribute('aria-label', `Go to slide group ${i + 1} of ${dotCount}`);
      btn.setAttribute('aria-controls', this.slider.id);
      btn.innerHTML = '<span class="dot"></span>';
      btn.addEventListener('click', () => this.goToDotPage(i));
      dotContainer.appendChild(btn);
      this.sliderControlLinksArray.push(btn);
    }

    this.updateDots();
  }

  goToDotPage(dotIndex) {
    const total = this.sliderItemsToShow.length;
    const perView = this.getSlidesPerView();
    const dotCount = Math.ceil(total / perView);

    let targetSlideIndex;

    if (dotIndex === dotCount - 1) {
      targetSlideIndex = total - perView;
    } else {
      targetSlideIndex = dotIndex * perView;
    }

    targetSlideIndex = Math.max(0, targetSlideIndex);

    const slideWidth = this.sliderItemsToShow[0].clientWidth;
    const gap = parseInt(getComputedStyle(this.slider).columnGap) || 28;

    this.slider.scrollTo({
      left: targetSlideIndex * (slideWidth + gap),
      behavior: 'smooth'
    });
  }

  updateDots() {
    if (!this.sliderControlLinksArray || !this.sliderControlLinksArray.length) return;

    const total = this.sliderItemsToShow.length;
    const perView = this.getSlidesPerView();
    const dotCount = Math.ceil(total / perView);

    const slideWidth = this.sliderItemsToShow[0]?.clientWidth || 1;
    const gap = parseInt(getComputedStyle(this.slider).columnGap) || 28;
    const scrollLeft = this.slider.scrollLeft;
    const currentSlideIndex = Math.round(scrollLeft / (slideWidth + gap));

    let activeDot;
    if (currentSlideIndex >= total - perView) {
      activeDot = dotCount - 1;
    } else {
      activeDot = Math.floor(currentSlideIndex / perView);
    }

    this.sliderControlLinksArray.forEach((btn, i) => {
      const isActive = i === activeDot;
      btn.classList.toggle('slider-counter__link--active', isActive);
      btn.toggleAttribute('aria-current', isActive);
    });
  }

  onResize() {
    const perView = this.getSlidesPerView();
    if (perView !== this._lastSlidesPerView) {
      this._lastSlidesPerView = perView;
      this.buildDots();
    }
  }

  update() {
    if (!this.sliderControlButtons || this.sliderControlButtons.length === 0) {
      this.sliderControlButtons = Array.from(this.querySelectorAll('.slider-counter__link'));
    }

    const slideWidth = this.sliderItemsToShow[0].clientWidth;
    const gap = parseInt(getComputedStyle(this.slider).columnGap) || 28;
    const firstVisibleSlide = Math.round(this.slider.scrollLeft / (slideWidth + gap));

    let currentSlideIndex = Math.max(0, Math.min(firstVisibleSlide, this.sliderItemsToShow.length - 1));
    this.currentPage = currentSlideIndex + 1;

    if (!this.enableSliderLooping) {
      this.prevButton.toggleAttribute('disabled', currentSlideIndex === 0);
      this.nextButton.toggleAttribute('disabled', currentSlideIndex === this.sliderItemsToShow.length - 1);
    }

    this.updateDots();
    this.updateArrowState();

    if (this.currentPage !== this._lastPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[currentSlideIndex]
        }
      }));
      this._lastPage = this.currentPage;
    }
  }

  initVideoControls() {
    const slides = this.querySelectorAll('.slideshow__slide');
    slides.forEach((slide) => {
      const video = slide.querySelector('.slider-video-player');
      const playPauseBtn = slide.querySelector('.video-play-pause');
      const muteBtn = slide.querySelector('.video-mute');
      if (!video || !playPauseBtn || !muteBtn) return;
      playPauseBtn.addEventListener('click', () => this.togglePlayPause(video, playPauseBtn));
      muteBtn.addEventListener('click', () => this.toggleMute(video, muteBtn));
    });
  }

  togglePlayPause(video, button) {
    const iconPlay = button.querySelector('.icon-play');
    const iconPause = button.querySelector('.icon-pause');
    if (video.paused) {
      this.pauseAllVideos(video);
      video.play();
      iconPlay.style.display  = 'none';
      iconPause.style.display = 'block';
      button.setAttribute('aria-label', 'Pause video');
    } else {
      video.pause();
      iconPlay.style.display  = 'block';
      iconPause.style.display = 'none';
      button.setAttribute('aria-label', 'Play video');
    }
  }

  pauseAllVideos(exceptVideo) {
    const slides = this.querySelectorAll('.slideshow__slide');
    slides.forEach((slide) => {
      const video = slide.querySelector('.slider-video-player');
      const playPauseBtn = slide.querySelector('.video-play-pause');
      if (!video || !playPauseBtn || video === exceptVideo) return;
      if (!video.paused) {
        video.pause();
        const iconPlay = playPauseBtn.querySelector('.icon-play');
        const iconPause = playPauseBtn.querySelector('.icon-pause');
        iconPlay.style.display  = 'block';
        iconPause.style.display = 'none';
        playPauseBtn.setAttribute('aria-label', 'Play video');
      }
    });
  }

  toggleMute(video, button) {
    const iconMuted   = button.querySelector('.icon-muted');
    const iconUnmuted = button.querySelector('.icon-unmuted');
    video.muted = !video.muted;
    if (video.muted) {
      iconMuted.style.display   = 'block';
      iconUnmuted.style.display = 'none';
      button.setAttribute('aria-label', 'Unmute video');
    } else {
      iconMuted.style.display   = 'none';
      iconUnmuted.style.display = 'block';
      button.setAttribute('aria-label', 'Mute video');
    }
  }

  updateArrowState() {
    if (!this.prevButton || !this.nextButton) return;
    const scrollLeft = this.slider.scrollLeft;
    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
    this.prevButton.disabled = scrollLeft <= 0;
    this.prevButton.setAttribute('aria-disabled', String(scrollLeft <= 0));
    this.nextButton.disabled = scrollLeft >= maxScroll - 1;
    this.nextButton.setAttribute('aria-disabled', String(scrollLeft >= maxScroll - 1));
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.sliderAutoplayButton.addEventListener('click', this.focusInHandling.bind(this));
    this.addEventListener('mouseover',  this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin',    this.focusInHandling.bind(this));
    this.addEventListener('focusout',   this.focusOutHandling.bind(this));
    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  isSlideVisible(element, offset = 0) {
    const sliderLeft  = this.slider.scrollLeft;
    const sliderRight = this.slider.scrollLeft + this.slider.clientWidth;
    const elemLeft    = element.offsetLeft;
    const elemRight   = element.offsetLeft + element.clientWidth;
    return elemLeft >= sliderLeft && elemRight <= sliderRight - offset;
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length
      ? 0
      : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({ left: slideScrollPosition });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      const video  = item.querySelector('.slider-video-player');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
        if (video) video.pause();
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({ left: slideScrollPosition });
  }
}

customElements.define('video-slideshow-component', VideoSlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.additionalVariantData = JSON.parse(document.getElementById('additionalVariantData').textContent);
    this.portafilterInput = document.querySelector('.js.product-form__input.portafilters input[type="radio"]');
    this.setColorVariantLabel();
    this.setPriceLabelAddButton();
    this.updateVariantMedia();
    this.addOutOfStockClass();
    if (this.portafilterInput) {
      this.handlePortafilterSelection('.js.product-form__input.portafilters input[type="radio"]');
    }
  }

  onVariantChange() {
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.setColorVariantLabel();
    this.removeColorVariantLabel();
    this.addOutOfStockClass();

    if (!this.currentVariant) {
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantMedia();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

   updateLabelClasses(radioSelector, selectedId) {
    document.querySelectorAll(radioSelector).forEach(function(radio) {
      const label = document.querySelector(`label[for="${radio.id}"]`);
      if (label) {
        label.classList.remove('first-swatch');
      }
    });
  
    const selectedLabel = document.querySelector(`label[for="${selectedId}"]`);
    if (selectedLabel) {
      selectedLabel.classList.add('first-swatch');
    }
  }

  handlePortafilterSelection(radioSelector) {
    const urlParams = new URLSearchParams(window.location.search);
    const portafilterHandle = urlParams.get('portafilter');
    const portafiltersData = JSON.parse(this.getPortafilterData());
    const mainSkuInventory = document.querySelector('#main-sku-inventory').getAttribute('main-sku-inventory');

    document.querySelectorAll(radioSelector).forEach((radio, index) => {
        let firstPortafilterAvailable = false;

        if (index === 0 && !portafilterHandle) {
            const firstPortafilter = portafiltersData.find(p => p.handle.includes(radio.value));

            if (Number(firstPortafilter.inventory) === 0 || Number(mainSkuInventory) === 0) {
                this.toggleAddButton(true, window.variantStrings.soldOut);
            } else {
                this.toggleAddButton(false, window.variantStrings.addToCart);
                firstPortafilterAvailable = true;
            }
        }

        if (portafilterHandle && radio.value === portafilterHandle) {
            radio.checked = true;
            this.updateLabelClasses(radioSelector, radio.id);
            this.updateLegendLabel(portafilterHandle);
            const selectedPortafilter = portafiltersData.find(p => p.handle.includes(portafilterHandle));

            if (Number(selectedPortafilter.inventory) === 0 || Number(mainSkuInventory) === 0) {
                this.toggleAddButton(true, window.variantStrings.soldOut);
            } else {
                this.toggleAddButton(false, window.variantStrings.addToCart);
            }
        }

        radio.addEventListener('click', () => {
            const selectedHandle = radio.value;
            const selectedPortafilter = portafiltersData.find(p => p.handle.includes(selectedHandle));
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('portafilter', selectedHandle);
            this.updateURL(currentUrl);

            this.updateLabelClasses(radioSelector, radio.id);
            this.updateLegendLabel(selectedHandle);
            this.updateColorLinksWithPortafilter(selectedHandle);
            this.showHideMedia(selectedHandle, document.querySelectorAll(".thumbnail-list__item img"), document.querySelectorAll(".product__media-item img"));

            if (Number(selectedPortafilter.inventory) === 0 || Number(mainSkuInventory) === 0) {
                this.toggleAddButton(true, window.variantStrings.soldOut);
            } else {
                this.toggleAddButton(false, window.variantStrings.addToCart);
            }
        });
    });

    const checkedRadio = document.querySelector(`${radioSelector}:checked`);
    if (checkedRadio) {
        this.updateLabelClasses(radioSelector, checkedRadio.id);
        this.updateColorLinksWithPortafilter(checkedRadio.value);
        this.updateLegendLabel(checkedRadio.value);
        this.showHideMedia(checkedRadio.value, document.querySelectorAll(".thumbnail-list__item img"), document.querySelectorAll(".product__media-item img"));
    }
  }

  updateLegendLabel(portafilterValue) {
    const legendElement = document.querySelector('.portafilter_label');
    const inputElement = document.querySelector(`input[name="portafilter"][value="${portafilterValue}"]`);
    const formattedValue = portafilterValue.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    const upcharge = inputElement.getAttribute('upcharge');
    let upchargeText = '';

    if (upcharge) {
      const formattedUpcharge = (parseFloat(upcharge) / 100).toFixed(2);
      upchargeText = ` + $${formattedUpcharge}`;
    }

    legendElement.innerHTML = `<span>Portafilter: </span><span class="color__bold">${formattedValue}${upchargeText}</span>`;
  }

  updateColorLinksWithPortafilter(portafilterValue) {
    const colorLinks = document.querySelectorAll('.js.product-form__input a');
    colorLinks.forEach(function(link) {
      link.addEventListener('click', function(event) {
        event.preventDefault(); 
        const newUrl = new URL(link.href);
        newUrl.searchParams.set('portafilter', portafilterValue);
        window.location.href = newUrl.toString();
      });
    });
  }

  showHideMedia(searchValue, thumbs, stackedThumbs) {
    searchValue = searchValue.split(" ").join("-").toLowerCase();
    if (thumbs.length > 0) {
      let visibleCount = 0;

      thumbs.forEach(t => {
        const splitUrl = t.src.split('__');

        if(splitUrl[1].includes(searchValue)) {
          t.parentElement.parentElement.style.display = "block";
          visibleCount++;
        } else {
          t.parentElement.parentElement.style.display = "none";
        }
      });
     
      if (visibleCount <= 1) {
        document.querySelector('.thumbnail-slider').style.display = "none";
      } else {
        document.querySelector('.thumbnail-slider').style.display = "flex";
      }

      const sliderButtons = document.querySelectorAll('.carousel-slider .slider-button');

      sliderButtons.forEach(button => {
        if (visibleCount < 6) {
          button.style.display = "none";
        } else {
          button.style.display = "block";
        }
      });
    }

    if (stackedThumbs.length > 0) {
      let isFirstMatchFound = false; 
    
      stackedThumbs.forEach(t => {
        const splitUrl = t.src.split('__');
      
        if(splitUrl[1].includes(searchValue)) {
          t.parentElement.parentElement.parentElement.style.display = "block";
    
          if (!isFirstMatchFound) {
            t.parentElement.parentElement.parentElement.classList.add('is-active');
            isFirstMatchFound = true;
          } else {
            t.parentElement.parentElement.parentElement.classList.remove('is-active');
          }
    
        } else {
          t.parentElement.parentElement.parentElement.style.display = "none";
          t.parentElement.parentElement.parentElement.classList.remove('is-active');
        }
      });
    }
  }

  updateOptions() {
    let swatches = this.querySelectorAll('input');

    if (swatches.length == 0) {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    } else {
      this.inputs = Array.from(swatches).find((radio) => radio.checked).value;
      this.index = Number(document.querySelector('fieldset').getAttribute("node-index"));
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
      this.options.splice(this.index, 0, this.inputs)
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  addOutOfStockClass() {
    const variants = this.getVariantData();
    if (!this.currentVariant) {
      if (variants.length === undefined) {
        this.currentVariant = variants
      } else {
        for (let variant of variants) {
          if (variant.available) {
            this.currentVariant = variant
            break
          }
        }
      }
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateVariantMedia() {
    let color_inputs = document.querySelectorAll("input[name=Color]");
    let color_dropdown = document.querySelectorAll("select[name='options[Color]']");
    let thumbs = document.querySelectorAll(".thumbnail-list__item img");
    let stackedThumbs = document.querySelectorAll(".product__media-item  img");

    if (color_inputs.length > 0 ) {
      color_inputs.forEach(i => {
        //Check if swatch input or dropdown
        if (i.checked) {
          if(thumbs.length > 0) {
            thumbs.forEach(t => {
              let searchValue = i.value.split(" ").join("-").toLowerCase();
              if(t.src.includes(searchValue)) {
                t.parentElement.parentElement.style.display = "block";
              } else {
                t.parentElement.parentElement.style.display = "none"
              }
            })
          }

          if (stackedThumbs.length > 0 ) {
            stackedThumbs.forEach(t => {
              let searchValue = i.value.split(" ").join("-").toLowerCase();
              if(t.src.includes(searchValue)) {
                t.parentElement.parentElement.parentElement.style.display = "block";
              } else {
                t.parentElement.parentElement.parentElement.style.display = "none"
              }
            })
          }
        }
      })
    } else {
        if (thumbs.length > 0) {
          thumbs.forEach(t => {
            if(color_dropdown[0] != null){
              let searchValue = color_dropdown[0].value.split(" ")[0].toLowerCase();
              if(t.src.includes(searchValue)) {
                t.parentElement.parentElement.style.display = "block";
              } else {
                t.parentElement.parentElement.style.display = "none"
              }
            }
          })
        }

        if (stackedThumbs.length > 0 ) {
          stackedThumbs.forEach(t => {
            if(color_dropdown[0] != null){
              let searchValue = color_dropdown[0].value.split(" ")[0].toLowerCase();
              if(t.src.includes(searchValue)) {
                t.parentElement.parentElement.style.display = "block";
              } else {
                t.parentElement.parentElement.style.display = "none"
              }
            }
          })
        }
    }
  }

  updateURL(url) {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', url);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateMaxVariantQuantity() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantID = urlParams.get('variant');
    const variantData = this.additionalVariantData[variantID];
    const quantityInput = document.querySelector('.product input[name="quantity"]');

    if (Number(quantityInput.value) == 0) {
      quantityInput.value = 1;
    }

    //Check first if negative number
    if(Number(variantData.inventory) > 0) {
      if(Number(quantityInput.value) > Number(variantData.inventory)) {
        quantityInput.value = variantData.inventory;
        quantityInput.setAttribute('max', variantData.inventory);
      }
    }
    //If current inventory returns as negative, set the quantity value to 1
    //If its out of stock, the button will be disabled anyway
    //If it's negative but set to Not Track, setting to 1 will ensure they can still buy
    else if (Number(variantData.inventory) < 0) {
      quantityInput.value = 1;
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const stickyForm = document.querySelector('#sticky-form');
    const updateFormButton = (form) => {
      if (!form) return;
      const addButton = form.querySelector('[name="add"]');
      const addButtonText = form.querySelector('[name="add"] > span');
      let price = document.querySelector(".price-item").innerText;
      let hidePrice = document.querySelector("[data-hide-price]").dataset.hidePrice;

      if (!addButton) return;

      if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
      } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = text;
          
          if (hidePrice != "true") {
              addButtonText.textContent = window.variantStrings.addToCart + " - " + price;
          }
      }

      if (!modifyClass) return;
    };

    updateFormButton(productForm);
    if (stickyForm) {
      updateFormButton(stickyForm);
    }
  }

  setPriceLabelAddButton() {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const button = productForm.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    let price = document.querySelector(".price-item").innerText;
    let hidePrice = document.querySelector("[data-hide-price]").dataset.hidePrice;

    if (button.hasAttribute('disabled')) {
      addButtonText.textContent = window.variantStrings.soldOut;
    } else {
      if(hidePrice != "true") {
        addButtonText.textContent = window.variantStrings.addToCart + " - " + price;
      }
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getPortafilterData() {
    const portafiltersDataElement = document.querySelector('#portafilters_inventory');
    const portafiltersData = JSON.parse(portafiltersDataElement.textContent);
    return portafiltersData;
  }

  setColorVariantLabel() {
    let colorLabel = document.querySelector(".color_label");
    let colorInputs = document.querySelectorAll("input[name=Color]")

    for (var i = 0; i < colorInputs.length; i++) {
      if (colorInputs[i].checked) {
      colorLabel.innerHTML += "<span class='color__variant'>: " + colorInputs[i].value + "</span>"
      }
    }
  }

  removeColorVariantLabel() {
    let colorVariant = document.querySelector(".color__variant");
      if (colorVariant !== 'undefined' && colorVariant !== null) {
      colorVariant.remove()
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

// TODO Move this to quantityInput
/** Setting Quantity input to maximum product quantity on keyboard input **/
const quantityInput = document.querySelector('.product input[name="quantity"]');
if (quantityInput) {
  quantityInput.addEventListener('change', function() {
  let qtyMax = quantityInput.getAttribute("max");
  if (qtyMax != null && Number(quantityInput.value) > qtyMax) {
    quantityInput.value = (qtyMax != 0) ? qtyMax : 1;
  }
})
};

// TODO Fix errors Task: https://cqlcorp.atlassian.net/browse/CQLSTD-151
// class Accordion {
//   constructor(el) {
//     this.el = el;
//     this.summary = el.querySelector('summary');
//     this.content = el.querySelector('.accordion__content'); <-- Not all accordion content has this class. Causes errors on shop password, product, and possibly more.
//     this.animation = null;
//     this.isClosing = false;
//     this.isExpanding = false;
//     this.summary.addEventListener('click', (e) => this.onClick(e));
//   }

//   // Function called when user clicks on the summary
//   onClick(e) {
//     e.preventDefault();
//     this.el.style.overflow = 'hidden';
//     if (this.isClosing || !this.el.open) {
//       this.open();
//     } else if (this.isExpanding || this.el.open) {
//       this.close();
//     }
//   }

//   // Function called to close the content with an animation
//   close() {
//     this.isClosing = true;
//     const initialHeight = `${this.el.offsetHeight}px`;
//     const endHeight = `${this.summary.offsetHeight}px`;
  
//     if (this.animation) {
//       this.animation.cancel();
//     }
  
//     this.animation = this.el.animate({
//       height: [initialHeight, endHeight]
//     }, {
//       duration: 300,
//       easing: 'ease-out'
//     });
  
//     this.animation.onfinish = () => this.onAnimationFinish(false);
//     this.animation.oncancel = () => this.isClosing = false;
//   }

//   // Function called to open the element after click
//   open() {
//     this.el.style.height = `${this.el.offsetHeight}px`;
//     this.el.open = true;
//     window.requestAnimationFrame(() => this.expand());
//   }

//   // Function called to expand the content with an animation
//   expand() {
//     this.isExpanding = true;
//     const initialHeight = `${this.el.offsetHeight}px`;
//     const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
  
//     if (this.animation) {
//       this.animation.cancel();
//     }
  
//     this.animation = this.el.animate({
//       height: [initialHeight, endHeight]
//     }, {
//       duration: 300,
//       easing: 'ease-out'
//     });

//     this.animation = this.el.animate({
//       height: [initialHeight, endHeight]
//     }, {
//       duration: 300,
//       easing: 'ease-out'
//     });

//     this.animation = this.content.animate({
//       opacity: [0, 1]
//     }, {
//       duration: 300,
//       easing: 'ease-in'
//     });

//     this.animation.onfinish = () => this.onAnimationFinish(true);
//     this.animation.oncancel = () => this.isExpanding = false;
//   }

//   // Callback when the close or expand animations are done
//   onAnimationFinish(open) {
//     this.el.open = open;
//     this.animation = null;
//     this.isClosing = false;
//     this.isExpanding = false;
//     this.el.style.height = this.el.style.overflow = '';
//   }
// }

// // Instancing accoordions
// document.querySelectorAll('details').forEach((el) => {
//   new Accordion(el);
// });

class CompareSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Compare-Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Compare-Slide-"]');
    this.compareContainer = this.querySelector('.product-compare-slider-container');
    this.enableSliderLooping = false;
    this.currentPageElement = this.slider.querySelector('.slider-counter--current');
    this.pageTotalElement = this.slider.querySelector('.slider-counter--total');

    if (!this.slider) return;

    this.isDesktop = window.innerWidth >= 990;
    if (this.isDesktop) {
      this.sliderControls = document.querySelector('.product-compare-slider .slider-controls');
      if (!this.sliderControls) return;
      this.sliderControlNext = this.sliderControls.querySelector('.slider-control--next');
      this.sliderControlPrev = this.sliderControls.querySelector('.slider-control--prev');

      if (this.sliderControlNext) {
        this.sliderControlNext.addEventListener('click', this.onControlClick.bind(this));
        this.sliderControlNext.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.onControlClick(event);
          }
        });
      }

      if (this.sliderControlPrev) {
        this.sliderControlPrev.addEventListener('click', this.onControlClickPrev.bind(this));
        this.sliderControlPrev.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.onControlClickPrev(event);
          }
        });
      }
    }

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));

    this.initDots();

    this.isDragging = false;
    this.startX = 0;
    this.scrollLeft = 0;
    this.hasDragged = false;
    this.slider.addEventListener('mousedown', this.startDragging.bind(this));
    this.slider.addEventListener('mousemove', this.drag.bind(this));
    this.slider.addEventListener('mouseup', this.stopDragging.bind(this));
    this.slider.addEventListener('mouseleave', this.stopDragging.bind(this));
    this.slider.addEventListener('dragstart', (e) => e.preventDefault());
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);

    if (this.isDesktop) {
      this.totalPages = this.sliderItemsToShow.length;
    } else {
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    }

    this.updateDots();
    this.update();
  }

  goToPage(pageNumber) {
    const targetIndex = pageNumber - 1;
    if (targetIndex >= 0 && targetIndex < this.sliderItemsToShow.length) {
      const targetScrollLeft = this.sliderItemsToShow[targetIndex].offsetLeft;

      this.slider.scrollTo({
        left: targetScrollLeft,
        behavior: 'smooth'
      });
    }
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Compare-Slide-"]');
    this.initPages();
  }

  update() {
    if (this.isScrolling) return;

    const previousPage = this.currentPage;

    if (this.isDesktop) {
      const scrollLeft = this.slider.scrollLeft;
      
      let closestIndex = 0;
      let closestDistance = Math.abs(this.sliderItemsToShow[0].offsetLeft - scrollLeft);

      for (let i = 1; i < this.sliderItemsToShow.length; i++) {
        const distance = Math.abs(this.sliderItemsToShow[i].offsetLeft - scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      }

      this.currentPage = closestIndex + 1;
    } else {
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));

      this.updateActiveDot();
    }

    if (this.enableSliderLooping) return;

    const isAtEnd = Math.abs(this.slider.scrollLeft + this.slider.clientWidth - this.slider.scrollWidth) < 5;

    if (this.sliderControlNext) {
      if (isAtEnd) {
        this.sliderControlNext.setAttribute('disabled', 'disabled');
        this.sliderControlNext.setAttribute('aria-disabled', 'true');
      } else {
        this.sliderControlNext.removeAttribute('disabled');
        this.sliderControlNext.removeAttribute('aria-disabled');
      }
    }

    if (this.sliderControlPrev) {
      if (this.currentPage === 1) {
        this.sliderControlPrev.setAttribute('disabled', 'disabled');
        this.sliderControlPrev.setAttribute('aria-disabled', 'true');
      } else {
        this.sliderControlPrev.removeAttribute('disabled');
        this.sliderControlPrev.removeAttribute('aria-disabled');
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  onControlClick(event) {
    event.preventDefault();

    if (!this.sliderItemsToShow || this.sliderItemsToShow.length === 0) return;

    this.isScrolling = true;

    const scrollLeft = this.slider.scrollLeft;
    let currentIndex = 0;
    let closestDistance = Math.abs(this.sliderItemsToShow[0].offsetLeft - scrollLeft);

    for (let i = 1; i < this.sliderItemsToShow.length; i++) {
      const distance = Math.abs(this.sliderItemsToShow[i].offsetLeft - scrollLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        currentIndex = i;
      }
    }

    const nextIndex = Math.min(currentIndex + 1, this.sliderItemsToShow.length - 1);
    const targetScrollLeft = this.sliderItemsToShow[nextIndex].offsetLeft;

    this.slider.scrollTo({
      left: targetScrollLeft,
      behavior: 'smooth'
    });

    setTimeout(() => {
      this.isScrolling = false;
      this.update();
    }, 500);
  }

  onControlClickPrev(event) {
    event.preventDefault();

    if (!this.sliderItemsToShow || this.sliderItemsToShow.length === 0) return;

    this.isScrolling = true;

    const scrollLeft = this.slider.scrollLeft;
    let currentIndex = 0;
    let closestDistance = Math.abs(this.sliderItemsToShow[0].offsetLeft - scrollLeft);

    for (let i = 1; i < this.sliderItemsToShow.length; i++) {
      const distance = Math.abs(this.sliderItemsToShow[i].offsetLeft - scrollLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        currentIndex = i;
      }
    }

    const prevIndex = Math.max(currentIndex - 1, 0);
    const targetScrollLeft = this.sliderItemsToShow[prevIndex].offsetLeft;

    this.slider.scrollTo({
      left: targetScrollLeft,
      behavior: 'smooth'
    });

    setTimeout(() => {
      this.isScrolling = false;
      this.update();
    }, 500);
  }

  initDots() {
    if (this.isDesktop) return;

    this.dotsContainer = this.compareContainer.querySelector('.slider-counter');
    if (!this.dotsContainer) return;

    this.dotsContainer.setAttribute('role', 'tablist');
    this.updateDots();
  }

  updateDots() {
    if (this.isDesktop || !this.dotsContainer) return;

    this.dotsContainer.innerHTML = '';

    for (let i = 0; i < this.totalPages; i++) {
      const dot = document.createElement('button');
      dot.className = 'slider-dot';
      dot.setAttribute('type', 'button');
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
      dot.dataset.page = i + 1;

      if (i + 1 === this.currentPage) {
        dot.classList.add('slider-dot--active');
        dot.setAttribute('aria-current', 'true');
        dot.setAttribute('aria-selected', 'true');
      } else {
        dot.setAttribute('aria-selected', 'false');
      }

      dot.addEventListener('click', (e) => {
        e.preventDefault();
        this.goToPage(parseInt(dot.dataset.page));
      });

      this.dotsContainer.appendChild(dot);
    }
  }

  updateActiveDot() {
    if (this.isDesktop || !this.dotsContainer) return;

    const dots = this.dotsContainer.querySelectorAll('.slider-dot');
    dots.forEach((dot, index) => {
      if (index === this.currentPage - 1) {
        dot.classList.add('slider-dot--active');
        dot.setAttribute('aria-current', 'true');
        dot.setAttribute('aria-selected', 'true');
      } else {
        dot.classList.remove('slider-dot--active');
        dot.removeAttribute('aria-current');
        dot.setAttribute('aria-selected', 'false');
      }
    });
  }

  startDragging(e) {
    if (e.target.closest('a, button')) return;

    this.isDragging = true;
    this.hasDragged = false;
    this.startX = e.pageX;
    this.scrollLeft = this.slider.scrollLeft;
    this.slider.style.cursor = 'grabbing';
    this.slider.style.userSelect = 'none';
  }

  drag(e) {
    if (!this.isDragging) return;
    e.preventDefault();

    const x = e.pageX;
    const distance = x - this.startX;
    
    if (Math.abs(distance) > 3) {
      this.hasDragged = true;
    }

    this.slider.scrollLeft = this.scrollLeft - distance;
  }

  stopDragging(e) {
    if (!this.isDragging) return;

    this.isDragging = false;
    this.slider.style.cursor = 'grab';
    this.slider.style.userSelect = '';

    if (this.hasDragged && this.sliderItemsToShow.length > 0) {
      const slideWidth = this.sliderItemsToShow[0].offsetWidth + 16;
      const currentScroll = this.slider.scrollLeft;
      const nearestIndex = Math.round(currentScroll / slideWidth);
      const targetScroll = nearestIndex * slideWidth;

      this.slider.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    }

    setTimeout(() => {
      this.hasDragged = false;
    }, 100);
  }
}
customElements.define('product-compare-slider', CompareSlider);

function customUpdateProduct(variantKeys, quantity, _this, isMaxed, drawerItemIndex) {
  const updates = {};
  variantKeys.forEach((item) => {
    if (item.length){
      updates[item] = quantity;
    }
  })

  fetch('/cart.js')
  .then(response => response.json())
  .then(cartData => {
      const lineItem = cartData.items.find(item => item.variant_id === parseInt(variantKeys[0]));
      if (lineItem) {
        const cartItems = _this.closest('cart-items') || _this.closest('cart-drawer-items');
        cartItems.enableLoading(_this.dataset.index);

          fetch('/cart/update.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                  updates,
                  sections: cartItems.getSectionsToRender().map((section) => section.section),
                  sections_url: window.location.pathname
              }),
          })
          .then(response => {
              if (!response.ok) {
                  throw new Error('Failed. Status: ' + response.status);
              }
              return response.text()
          })
          .then(state => {

            const parsedState = JSON.parse(state);

            cartItems.getSectionsToRender().forEach((section => {
              const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
              elementToReplace.innerHTML = cartItems.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }));
            if (parsedState.item_count === 0){
              cartItems.classList.add('is-empty')
            }

            const isCartPage = window.location.pathname === '/cart';
            isCartPage ? window.location.reload() : null  
          })
          .catch(error => {
              console.error('Error occurred:', error);
          })
          .finally(() => {
            if (isMaxed && drawerItemIndex){
              cartItems.updateLiveRegions(drawerItemIndex, cartStrings.maxQuantity);
            }
            cartItems.disableLoading(_this.dataset.index);
            if (document.querySelector('cart-drawer-items')) {
              if (document.querySelector('cart-drawer-items').classList.contains('is-empty')){
                renderCartFeaturedLinks('cart-drawer__featured-links-placeholder');
              }
            }
          })
      } else {
          console.log(`Item with variant ID ${variantKeys} not found in the cart`);
      }
  })
  .catch(error => {
      console.error('Error fetching cart:', error);
  });
}


class CartBundleRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      
      const mainItem = event.currentTarget.dataset.key;
      const additionalItems = event.currentTarget.dataset.additionalItems;
      let variantKeys = [mainItem]
      if (additionalItems){
        additionalItems.split(',').forEach((additionalItem) => {
          additionalItem.split('||').forEach((itemKey) => {
            if (itemKey.indexOf('key') > -1){
              variantKeys.push(itemKey.split('|')[1])
            }
          })
        })
      }

      customUpdateProduct(variantKeys, 0, event.currentTarget);
    });
  }
}

customElements.define('cart-bundle-remove-button', CartBundleRemoveButton);

const renderCartFeaturedLinks = (id) => {
  fetch('/?section_id=featured-links-cart')
  .then(response => {
    return response.text()
  })
  .then(state => {
    const placeholder = document.getElementById(id);

    if (placeholder){
      placeholder.innerHTML = state;
      setTimeout(() => {
        placeholder.querySelector('.fadeIn')?.classList.add('inview');
      }, 100);
    }
  })
  .catch(error => {
      console.error('Error occurred:', error);
  })
}

// Cart Max-Quantity Calculations and custom quantity updates for Baristina and Gift bundles
customElements.whenDefined('cart-items').then(() => {

  const CartItems = customElements.get('cart-items');
  CartItems.prototype.onChange = async function(event) {
    const isDrawerUpdate = event.target.nodeName === 'CART-DRAWER-ITEMS';
    const target = isDrawerUpdate ? event.target.querySelector('[data-added-product="true"]') : event.target;
    const value = parseInt(target.value);
    const mainItem = target.dataset.key;
    const parentVariantId = target.dataset.variant;
    const additionalItems = target.dataset.additionalItems;
    const maxQuantity = parseInt(target.dataset.max) || Infinity;
    const line = target.dataset.index;
    let variantKeys = [mainItem];
    const lineItems = document.querySelectorAll(".cart-item");
    const previousValue = this.querySelector('.quantity__input')

    if (additionalItems) {
      additionalItems.split(',').forEach((additionalItem) => {
        additionalItem.split('||').forEach((itemKey) => {
          if (itemKey.indexOf('key') > -1) {
            variantKeys.push(itemKey.split('|')[1]);
          }
        });
      });
    }

    try {
      const cartData = await fetch('/cart.js').then(response => response.json());
      let currentParentQuantity = 0;

      cartData.items.forEach((item) => {
        if (item.id == parentVariantId) {
          currentParentQuantity += item.quantity;
        }
      });
     
      const newTotalQuantity = Number(currentParentQuantity) + (Number(value) - Number(target.dataset.originalquantity));

    

      if (newTotalQuantity > maxQuantity) {
        target.value = previousValue.getAttribute('value') ;
        lineItems.forEach( item => {
          if(item.dataset.variant == parentVariantId) {
              this.updateLiveRegions(item.id.split("-").pop(), cartStrings.maxQuantity);
          }
        });

        return;
    }

      isMaxed = newTotalQuantity == maxQuantity;

      if (additionalItems) {
        customUpdateProduct(variantKeys, value, target, isMaxed, line);
      } else {
        this.updateQuantity(line, value, document.activeElement.getAttribute('name'), isMaxed);
      }

    } catch (error) {
      console.error("Error fetching cart data or updating quantity:", error);
    }
  };

  renderCartFeaturedLinks('cart__featured-links-placeholder');
});

customElements.whenDefined('cart-drawer').then(() => {
  renderCartFeaturedLinks('cart-drawer__featured-links-placeholder');
})

document.addEventListener('DOMContentLoaded', function() {
  const upsellContainer = document.querySelector('.cart_relevant-upsells');
  const upsellTitle = document.querySelector('.cart_relevant_upsells__title');
  
  if (upsellContainer && upsellContainer.children.length === 0) {
      upsellTitle ? upsellTitle.style.display = 'none' : null
  } else {
      upsellTitle ? upsellTitle.style.display = 'block' : null
  }

  // Set default 'In Stock' query parameter filter for qualifying collections
  const mainContent = document.getElementById('MainContent');
  if (mainContent.getAttribute('data-in-stock-filter') === 'true') {
    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);

    if (!params.has('filter.v.availability')) {
      params.append('filter.v.availability', 1);
      window.location.search = params.toString();
    }
  }
});

document.querySelectorAll('.button').forEach((button) => {
  button.addEventListener('click', function () {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      'event': 'cta_button'
    });
  });
});